import styled from '@emotion/styled'

export const StyledApp = styled.div`

    background-color: ${({theme})=> theme.colors.background_color};
    color: ${({theme})=> theme.colors.main_color};
    /* position: relative;
    z-index: -2; */
  
`   